const TCPage = () => (
    <section id="work-section" className="hero d-flex align-items-center section-bg-w">
    <div className="container">
      <div className="row justify-content-between gy-5">
        <div className="col-lg-12 tutor-box w-100 d-flex flex-column justify-content-center text-center">
          <h2 data-aos="fade-up">Uslovi korišćenja</h2>
<h2>1. Prihvatanje uslova korišćenja</h2>
<p>
  1.1. Korišćenjem aplikacije za privatnu nastavu – casovi.me, korisnik platforme potvrđuje da je upoznat i saglasan sa odredbama i uslovima navedenim u daljem tekstu koji je obavezujući.
</p>
<p>
  1.2. Ovi uslovi korišćenja (u daljem tekstu „Uslovi“) primjenjuju se kao i ugovori u pisanoj formi, a zaključuju se između:  
  a) casovi.me – lice koje upravlja aplikacijom i  
  b) svakog pojedinačnog posjetioca/korisnika aplikacije (u daljem tekstu „Korisnik“).
</p>
<p>
  1.3. Casovi.me zadržava pravo da u bilo kom trenutku izmijeni uslove korišćenja i neće snositi odgovornost za posljedice koje mogu proizaći iz takve promjene. Izmjene uslova stupiće na snagu od dana kada su postavljene na sajtu, a nastavak korišćenja Aplikacije biće smatran pristankom na nove uslove.
</p>

<h2>2. Opis usluga</h2>
<ul>
  <li>Registrovani učenici i profesori organizuju privatne časove putem Aplikacije.</li>
  <li>Učenici mogu da pretražuju dostupne, registrovane profesore za predmete za koje im je potrebna privatna nastava.</li>
  <li>Casovi.me upravlja Aplikacijom i ima pristup komunikaciji između učenika i profesora nakon što učenik izabere profesora i zakaže čas, a profesor prihvati ponudu.</li>
</ul>

<h2>3. Registracija korisnika</h2>
<ul>
  <li>Za korišćenje Aplikacije potrebna je registracija – učenici i profesori moraju unijeti tačne podatke.</li>
  <li>Profesor unosi podatke (e-mail, broj telefona, predmete, radno vrijeme), a casovi.me pregledava prijave i šalje obavještenje o prihvatanju/odbijanju u roku od 24 sata.</li>
  <li>Učenici takođe unose podatke i nakon toga mogu pretraživati profesore.</li>
  <li>Za naplative usluge učenik mora imati najmanje 14, a profesor 18 godina (ili saglasnost zakonskog zastupnika).</li>
  <li>Casovi.me može tražiti dodatnu dokumentaciju i ukloniti lažne/sumnjive naloge.</li>
</ul>

<h2>4. Časovi / način održavanja časova</h2>
<ul>
  <li>Učenik bira profesora, rezerviše čas i dogovara detalje.</li>
  <li>Po potvrdi časa otvara se chat.</li>
  <li>U promotivnom periodu od 3 mjeseca aplikacija je besplatna za profesore; nakon toga pretplata je 10 € mjesečno.</li>
  <li>Korisnici su odgovorni za međusobne dogovore i kvalitet časova.</li>
</ul>

<h2>5. Prava i obaveze korisnika</h2>
<ul>
  <li>Otkazivanje/pomjeranje časa moguće je uz prethodan dogovor.</li>
  <li>Profesor mora potvrditi čas najkasnije 2 sata ranije i označiti ga kao održan.</li>
  <li>Učenik može otkazati čas do 2 sata ranije – u suprotnom, čas se naplaćuje. Recenzija je obavezna nakon svakog časa.</li>
  <li>Korisnici koji krše pravila mogu biti uklonjeni.</li>
  <li>Korisnici su odgovorni za poreske obaveze; casovi.me ne prijavljuje niti plaća poreze u ime korisnika.</li>
</ul>

<h2>6. Informacije o profesorima</h2>
<ul>
  <li>Profesori navode predmete i radno vrijeme.</li>
  <li>Kontakt podaci su povjerljivi, dok su CV i prosječna ocjena dostupni učenicima.</li>
  <li>Ocjene i komentari su javni i utiču na rangiranje profesora.</li>
  <li>Casovi.me ne uspostavlja radni odnos sa profesorima – oni djeluju nezavisno.</li>
</ul>

<h2>7. Upotreba aplikacije</h2>
<ul>
  <li>Aplikacija je dostupna 24/7, ali bez garancije neprekidnog rada.</li>
  <li>Sadržaj i dizajn Aplikacije zaštićeni su autorskim pravima.</li>
  <li>Korisnici moraju unositi istinite informacije i ne smiju objavljivati neprimjeren ili nezakonit sadržaj.</li>
  <li>Zabranjeno je postavljanje diskriminatornog, uvredljivog, štetnog, nezakonitog sadržaja ili spama.</li>
  <li>Casovi.me može obustaviti ili ograničiti usluge, te izvršiti promjene uz obavještenje.</li>
  <li>Korisnici mogu dobijati e-mailove sa adrese info@casovi.me.</li>
</ul>

<h2>8. Garancija</h2>
<ul>
  <li>Primjenjuju se odredbe Zakona o zaštiti potrošača.</li>
  <li>U slučaju nezadovoljstva učenik može podnijeti žalbu ili tražiti povraćaj novca.</li>
  <li>Kršenje pravila može dovesti do uklanjanja korisnika.</li>
  <li>Casovi.me ne garantuje kvalitet časova niti ispunjenje očekivanja korisnika.</li>
</ul>

<h2>9. Odgovornost</h2>
<ul>
  <li>Casovi.me djeluje kao posrednik između profesora i učenika.</li>
  <li>Dogovori o lokaciji, načinu i naknadi su odgovornost korisnika.</li>
  <li>Chat komunikacija je enkriptovana, ali casovi.me može pristupiti u slučaju zloupotrebe.</li>
  <li>Casovi.me ne odgovara za direktnu ili indirektnu štetu nastalu korišćenjem Aplikacije.</li>
  <li>Korisnici su odgovorni za sadržaj koji objavljuju (komentari, poruke, recenzije).</li>
</ul>

<h2>10. Ugovorni odnos</h2>
<p>Ugovor počinje registracijom i može se raskinuti brisanjem naloga.</p>

<h2>11. Završne odredbe</h2>
<ul>
  <li>Nevaženje pojedinih odredbi ne utiče na ostatak Uslova.</li>
  <li>Casovi.me može izmijeniti Uslove uz obavještenje na Aplikaciji – izmjene stupaju na snagu u roku od 7 dana.</li>
  <li>Sporove će strane pokušati riješiti mirnim putem, a ako to nije moguće, nadležan je sud u Podgorici.</li>
</ul>
        </div>
      </div>
    </div>
  </section>
);

export default TCPage;